import { unstable_ownerWindow as ownerWindow } from '@material-ui/utils';
export default ownerWindow;